
import { IReturn } from "@servicestack/client";
import { SWRConfiguration } from "swr";
import IGetConfiguration from '../../types/api/IGetConfiguration';
import { useMemo } from "react";
import useSwrClient from "./useSwrClient";

export const useGet = <T, D, E, A>(fn?: () => IReturn<T> | string, getConfiguration?: IGetConfiguration<T, D, E, A>, swrConfiguration?: SWRConfiguration | undefined) => {
    const { get } = useSwrClient();
    const response = get<T>(fn, swrConfiguration);

    const { getData, getError, getAdditionalState } = getConfiguration ?? {};

    const result = useMemo(() => {
        const d = getData?.(response);
        const e = getError?.(response);
        const a = getAdditionalState?.(response);

        const s = {
            data: d,
            error: e,
            loading: response.isValidating && !d && !e,
            validating: response.isValidating,
            mutate: response.mutate,
            refresh: async () => {
                const newResponse = await response.mutate(response.data, { revalidate: true })

                return getData?.(newResponse as any);
            }
        }

        return {
            ...s,
            ...a
        } as typeof s & A

    }, [getData, getError, response]);

    return result;
};

export default useGet;